export default __webpack_public_path__ + "static/media/principal-building.663c1287.png";